<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 700px">
            <!--<v-responsive :aspect-ratio="16 / 9">-->
            <v-card-title primary-title>
              <div>
                <div class="headline ps-2 pa-1">{{ $t("settingsPage.onboardingTitle") }}</div>
              </div>
            </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">

                <label style="font-size: large">{{ $t("settingsPage.voucherTitle") }}</label>
                <v-text-field outline v-model="model.title" :rules="[rules.required]" :label="$t('settingsPage.voucherTitle')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.voucherCode") }}</label>
                <v-text-field outline v-model="model.code" :rules="[rules.required]" :label="$t('settingsPage.voucherCode')" type="text"
                  style="margin-top: 15px"></v-text-field>


                <label style="font-size: large">{{ $t("settingsPage.periodDays") }}</label>
                <v-text-field outline v-model="model.period" :rules="[rules.required, rules.number]" :label="$t('settingsPage.period')"
                  type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settingsPage.discountType") }}</label>
                <v-select outline :label="$t('settingsPage.discountType')" :items="discountTypeItems" :rules="[rules.required]"
                  v-model="model.discount_type" />

                <label style="font-size: large">{{ $t("settingsPage.amount") }}</label>
                <v-text-field outline v-model="model.amount" :rules="[rules.required, rules.number]" :label="$t('settingsPage.amount')"
                  type="text" style="margin-top: 15px"></v-text-field>


                <v-btn :loading="loading" block @click="save" color="secondary">{{ $t("settingsPage.save") }}
                </v-btn>
              </v-form>
            </v-flex>
            <!--</v-responsive>-->
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("settingsPage.onboardingTitle");
  },
  name: "OnboardingVouchersSettings",
  data: () => ({
    loading: false,
    form: false,
    model: {
      title: "",
      code: "",
      period: 0,
      discount_type: "PERCENTAGE",
      amount: 0
    },
    originalModel: {},
    isDirty: false,
  }),
  computed: {
    // rules live in computed (not data) so validation messages re-resolve on locale switch
    rules() {
      return {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("settingsPage.ruleLength", { len }),
        required: (v) => !!v || this.$t("settingsPage.ruleRequired"),
        number: (v) => /^\d+(\.\d+)?$/.test(v) || this.$t("settingsPage.rulePositiveNumber"),
      };
    },
    // display text is translated; the value sent to the API stays the raw enum
    discountTypeItems() {
      return [
        { text: this.$t("settingsPage.discountTypePercentage"), value: "PERCENTAGE" },
        { text: this.$t("settingsPage.discountTypeFixed"), value: "FIXED" },
      ];
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    axios.get("onboarding-voucher").then((response) => {
      Object.assign(this.model, response.data.data);
      // Redenomination (display-only): FIXED amount is MONEY -> seed the input with
      // the plain new-unit NUMBER (old / 100), NOT formatMoney() — a grouped string
      // would make toStoredAmount() return NaN on save. PERCENTAGE amount stays as-is.
      if (this.model.discount_type === "FIXED" && this.model.amount != null) {
        this.model.amount = this.model.amount / 100;
      }
      this.originalModel = JSON.parse(JSON.stringify(this.model));

    });
  },
  beforeDestroy() {
    // alert("beforeDestroy");
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  watch: {
    model: {
      handler(newVal, oldVal) {
        if (Object.keys(this.originalModel).length > 0) {
          this.isDirty = JSON.stringify(newVal) !== JSON.stringify(this.originalModel);
        }
      },
      deep: true,
      immediate: false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      const answer = confirm(this.$t("settingsPage.unsavedChanges"));
      if (answer) {
        next(); // User confirmed, allow navigation
      } else {
        next(false); // User canceled, prevent navigation
      }
    } else {
      next(); // No unsaved changes, allow navigation
    }

  },
  methods: {
    handleBeforeUnload(event) {
      if (this.isDirty) {
        event.preventDefault();
        event.returnValue = this.$t("settingsPage.unsavedChanges");
      }
    },

    save() {
      if (!this.$refs.form.validate()) {
        window.getApp.$emit(
          "SHOW_TOAST",
          this.$t("settingsPage.enterValidValues"),
          "red"
        );
        return;
      }


      this.loading = true;

      // Redenomination (display-only): convert FIXED money amount back to stored units
      // on submit. PERCENTAGE amount is not money -> send as-is. Do not mutate v-model.
      const payload = { ...this.model };
      if (payload.discount_type === "FIXED") {
        payload.amount = this.toStoredAmount(payload.amount);
      }

      this.axios
        .put(`onboarding-voucher`, payload)
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("settingsPage.settingsSaved"))
          this.originalModel = JSON.parse(JSON.stringify(this.model));
          this.isDirty = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("settingsPage.failedSaveSettings"), "red");
          console.log(err.response);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
